<template>
  <div class="sites-screen"  v-if="model && model.sites">
    <page-header :title="$t('app.sites.title')"/>
    <div class="row mt-30">
      <div class="col-sm-6">
        <search-input :placeholder="$t('app.sites.search_input_placeholder')" @input="search"/>
      </div>
      <div class="col-sm-6 text-right" v-if="loggedInUser.role === 'admin'">
        <base-button
          :title="this.$t('app.generals.createNew')"
          classNames="btn btn-orange rounded pull-right"
          @clicked="clickedCreateSite"
        />
      </div>
    </div>
    <div class="row mt-30">
      <div class="col-sm-3">
        <base-dropdown
          :list="orderByList"
          v-model="orderBy"
          :defaultValue="orderBy"
          labelClassNames="control-label mb-10 text-left"
          :labelValue="$t(`app.sort.typeLabel`)"
          @input="orderTable"/>
      </div>
      <div class="col-sm-3">
        <base-dropdown
          :list="orderList"
          v-model="direction"
          :defaultValue="direction"
          labelClassNames="control-label mb-10 text-left"
          :labelValue="$t(`app.sort.sortLabel`)"
          @input="orderTable"/>
      </div>
    </div>
    <div
      v-for="(site, index) in model.sites"
      :key="index"
      class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mt-25"
    >
      <site-card
        :site="site"
        @selectSite="actionMade"
        @deleteSite="deleteSiteClicked"
        :needEdit="loggedInUser.role === 'admin'"
      />
    </div>
    <div class="clearfix"></div>
    <paginator-component
      :totalPages="totalPages"
      :currentPageIndex="currentPageIndex"
      @itemSelected="itemSelected"
    />
    <div class="partner-admin-table" v-if="loggedInUser.role === 'admin' || loggedInUser.role === 'partner_admin'">
      <div class="row text-left mt-5 mr-20" style="padding-left: 5px;">
      <base-button
        :title="$t('app.generals.createNew')"
        classNames="btn btn-orange rounded pull-right"
        @clicked="clickedCreateUser"
      />
    </div>
      <configurable-list
        :title="$t('app.tables.partnerAdminTable.title')"
        :data="this.partnerAdmins"
        :loadingText="loadingText"
        :fields="loggedInUser.role === 'admin' ? adminFields : partnerAdminFields"
        @actionMade="userActionMade"
        @orderTable="orderPartnerTable"
      />
      <paginator-component
      :totalPages="userTotalPages"
      :currentPageIndex="userCurrentPageIndex"
      @itemSelected="userItemSelected"
    />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Paginator from '@/components/shared/navigations/Paginator';
import BaseButton from '@/components/shared/buttons/BaseButton';
import GenericForm from '@/components/shared/forms/GenericForm';
import PageHeader from '@/components/shared/layouts/PageHeader';
import SearchInput from '@/components/shared/inputs/SearchInput';
import BaseDropdown from '@/components/shared/inputs/BaseDropDown';
import ConfigurableList from '@/components/shared/lists/ConfigurableList';
import SiteCard from './SiteCard';


export default {
  name: 'SitesScreen',
  components: {
    'paginator-component': Paginator,
    'base-button': BaseButton,
    SiteCard,
    PageHeader,
    SearchInput,
    BaseDropdown,
    ConfigurableList,
  },
  data() {
    return {
      orderBy: 'created_at',
      direction: 'DESC',
      model: undefined,
      currentPageIndex: 1,
      userCurrentPageIndex: 1,
      searchTerm: '',
      newSite: {
        name: undefined,
        address: undefined,
        contact: undefined,
        contact_phone: undefined,
        contact_email: undefined,
        post_code: undefined,
        city: undefined,
        eov_x: undefined,
        eov_y: undefined,
        land_register_reference: undefined,
      },
      siteAttributes: [
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'contact',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'contact_email',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'contact_phone',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'post_code',
          type: 'text',
          classes: 'col-md-4',
        },
        {
          name: 'city',
          type: 'text',
          classes: 'col-md-4',
        },
        {
          name: 'address',
          type: 'text',
          classes: 'col-md-4',
        },
        {
          name: 'land_register_reference',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'eov_x',
          type: 'number',
          classes: 'col-md-6',
        },
        {
          name: 'eov_y',
          type: 'number',
          classes: 'col-md-6',
        },
        {
          name: 'file',
          type: 'file',
          multiple: false,
        },
      ],
      partnerAdmins: [],
      specs: [],
      newUser: {
        name: undefined,
        email: undefined,
        phone: undefined,
        job: undefined,
        role: 'partner_admin',
        specializations: [],
      },
      selectedSpecs: [],
      userTotalPages: 0,
      mappedSpecs: [],
    };
  },
  created() {
    this.fetchSites({
      partnerId: this.loggedInUser.partner_id,
      pageIndex: this.currentPageIndex,
      searchTerm: this.searchTerm,
    }).then((response) => {
      this.model = response;
    });
    this.fetchPartnerAdmins({
        pageIndex: this.currentPageIndex,
        orderInfo: {
          order: this.order,
          direction: this.direction,
        },
      }).then((response) => {
      this.partnerAdmins = response.users;
      this.userTotalPages = response.total_pages;
    });

    this.fetchSpecs().then((response) => {
      this.specs = response.map(x => ({ value: x.id, text: this.$t(`app.specializations.${x.name}`) }));
      this.mappedSpecs = response.map(x => ({ value: x.id, text: this.$t(x.name) }));
    });
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    loadingText() {
      if (this.partnerAdmins && this.partnerAdmins.length === 0) {
        return this.$t('app.tasks.empty_list');
      }
      return this.$t('app.listLoading');
    },
    userAttributes() {
      return [
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'job',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'email',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'phone',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'note',
          type: 'text-area',
          classes: 'col-md-12',
        },
        {
          name: 'specializations',
          type: 'specializations-selector',
          classes: 'col-md-12',
        },
      ];
    },
    partnerAdminFields() {
      return [
        {
          title: this.$t('app.tables.partnerAdminTable.name'),
          cellClass: 'name-cell',
          key: 'name',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.userName'),
          cellClass: 'name-cell',
          key: 'user_name',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.email'),
          cellClass: 'email-cell',
          key: 'email',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.phone'),
          cellClass: 'phone-cell',
          key: 'phone',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.specializations'),
          cellClass: 'specs-cell',
          arrayAttribute: 'name',
          key: 'specializations',
          list: this.specs,
        },
      ];
    },
    adminFields() {
      return [
        {
          title: this.$t('app.tables.partnerAdminTable.name'),
          cellClass: 'name-cell',
          key: 'name',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.userName'),
          cellClass: 'name-cell',
          key: 'user_name',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.email'),
          cellClass: 'email-cell',
          key: 'email',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.phone'),
          cellClass: 'phone-cell',
          key: 'phone',
          orderable: true,
        },
        {
          title: this.$t('app.tables.partnerAdminTable.specializations'),
          cellClass: 'specs-cell',
          arrayAttribute: 'name',
          key: 'specializations',
          list: this.specs,
        },
        {
          title: this.$t('app.tables.global.actions'),
          isAction: true,
          cellClass: 'edit-cell',
          key: 'edit',
          class: 'zmdi zmdi-edit',
        },
        {
          title: '',
          isAction: true,
          cellClass: 'delete-cell',
          key: 'delete',
          class: 'zmdi zmdi-delete',
        },
      ];
    },
    totalPages() {
      return this.model.total_pages || 0;
    },
    orderList() {
      return [
        {
          text: this.$t('app.sort.descending'),
          value: 'DESC',
        },
        {
          text: this.$t('app.sort.ascending'),
          value: 'ASC',
        },
      ];
    },
    orderByList() {
      return [
        {
          text: this.$t('app.sort.partner.created_at'),
          value: 'created_at',
        },
        {
          text: this.$t('app.sort.partner.name'),
          value: 'name',
        },
      ];
    },
    mapAttributes() {
      return [
        {
          name: 'map_id',
          type: 'map',
          classes: 'col-md-12',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetchSites: 'sites/fetchSites',
      fetchSite: 'sites/fetchSite',
      createNewSite: 'sites/createSite',
      updatesiteParams: 'sites/updateSite',
      deleteSite: 'sites/deleteSite',
      fetchPartnerAdmins: 'users/fetchPartnerAdmins',
      fetchSpecs: 'users/fetchSpecs',
      createNewUser: 'users/createUser',
      fetchUser: 'users/fetchUser',
      updateUser: 'users/updateUser',
      deleteUser: 'users/deleteUser',
    }),
    orderPartnerTable(payload) {
      this.order = payload.order;
      this.direction = payload.direction;

      this.fetchPartnerAdmins({
        pageIndex: this.currentPageIndex,
        orderInfo: {
          order: payload.order,
          direction: payload.direction,
        },
      }).then((response) => {
        this.partnerAdmins = response.users;
        this.userTotalPages = response.total_pages;
      });
      
    },
    deleteSiteClicked(payload) {
      this.$swal
        .fire({
          html: this.$t('app.notifications.general_confirm.title'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
        })
        .then((result) => {
          if (result.value) {
            this.deleteSite({
              partnerId: this.loggedInUser.partner_id,
              id: payload,
            }).then(() => {
              this.fetchSites({
                partnerId: this.loggedInUser.partner_id,
                pageIndex: this.currentPageIndex,
                searchTerm: this.searchTerm,
              }).then((response) => {
                this.model = response;
              });
            }).catch((error) => {
              console.log(error);
            });
          }
        });
    },
    userActionMade(payload) {
      if (payload.actionType === 'edit') {
        this.fetchUser({
          id: payload.id,
        })
          .then((user) => {
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t('app.users.edit_worker'),
                fields: this.userAttributes,
                model: user,
                specializations: this.mappedSpecs,
                submitTitle: this.$t('app.users.buttons.save'),
                cancelTitle: this.$t('app.users.buttons.cancel'),
                modelName: 'users',
              },
              on: {
                submit: this.clickedUpdateUser,
              },
              width: '1000px',
            });
          })
          .catch((error) => {
            const mappedErrors = error.map(x => ` ${x}`);
            const errorMessages = this.$t('app.errors.general_validation', {
              message: mappedErrors,
            });
            this.$swal
              .fire({
                html: errorMessages,
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      } else if (payload.actionType === 'delete') {
        this.$swal
          .fire({
            html: this.$t('app.notifications.general_confirm.title'),
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
            cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
          })
          .then((result) => {
            if (result.value) {
              this.deleteUser({
                userId: payload.id,
              })
                .then(() => {
                  this.$eventBus.showNotification({
                    notificationText: this.$t('app.users.success.delete'),
                    notificationType: 'success',
                  });
                  this.fetchPartnerAdmins({
                    pageIndex: this.currentPageIndex,
                    orderInfo: {
                      order: this.order,
                      direction: this.direction,
                    },
                  }).then((response) => {
                    this.partnerAdmins = response.users;
                    this.userTotalPages = response.total_pages;
                  });
                })
                .catch((error) => {
                  this.$swal
                    .fire({
                      html: error[0],
                      type: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      focusConfirm: false,
                    });
                });
            }
          });
      }
    },
    clickedUpdateUser(user) {
      const hasObject = user.specializations.some(item => typeof item === 'object' && item !== null);
      if (hasObject) {
        user.specializations = []
      }
      this.updateUser({
        userId: user.id,
        params: user,
      })
        .then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.users.success.update'),
            notificationType: 'success',
          });
          this.fetchPartnerAdmins({
              pageIndex: this.currentPageIndex,
              orderInfo: {
                order: this.order,
                direction: this.direction,
              },
            }).then((response) => {
            this.partnerAdmins = response.users;
            this.$eventBus.hideModal();
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    createUser(newUser) {
      this.createNewUser({
        params: newUser,
      })
        .then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.users.success.create'),
            notificationType: 'success',
          });
          this.fetchPartnerAdmins({
            pageIndex: this.currentPageIndex,
            orderInfo: {
              order: this.order,
              direction: this.direction,
            },
          }).then((response) => {
            this.partnerAdmins = response.users;
            this.userTotalPages = response.total_pages;
            this.resetNewUser();
            this.$eventBus.hideModal();
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    resetNewUser() {
      Object.assign(this.$data.newUser, this.$options.data().newUser);
    },
    clickedCreateUser() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.users.set_worker'),
          fields: this.userAttributes,
          model: this.newUser,
          specializations: this.mappedSpecs,
          submitTitle: this.$t('app.users.buttons.save'),
          cancelTitle: this.$t('app.users.buttons.cancel'),
          modelName: 'users',
        },
        on: {
          submit: this.createUser,
          modalCanceled: this.resetNewUser,
        },
        width: '1000px',
      });
    },
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    userItemSelected(index) {
      this.userCurrentPageIndex = index;
    },
    clickedCreateSite() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.sites.set_site'),
          fields: this.siteAttributes,
          model: this.newSite,
          submitTitle: this.$t('app.sites.buttons.save'),
          cancelTitle: this.$t('app.sites.buttons.cancel'),
          modelName: 'sites',
        },
        on: {
          submit: this.createSite,
          modalCanceled: this.resetNewSite,
        },
      });
    },
    createSite(newSite) {
      this.createNewSite(
        {
          partnerId: this.loggedInUser.partner_id,
          params: newSite,
        },
      )
        .then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.sites.success.create'),
            notificationType: 'success',
          });
          this.fetchSites({
            partnerId: this.loggedInUser.partner_id,
            pageIndex: this.currentPageIndex,
            searchTerm: this.searchTerm,
          })
            .then((response) => {
              this.model = response;
              this.resetNewSite();
              this.$eventBus.hideModal();
            })
            .catch(() => {
              this.$swal
                .fire({
                  html: this.$t('app.partners.errors.deletion_error'),
                  type: 'error',
                  showCloseButton: true,
                  showCancelButton: false,
                  showConfirmButton: false,
                  focusConfirm: false,
                });
            });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    resetNewSite() {
      Object.assign(this.$data.newSite, this.$options.data().newSite);
    },
    updateSite(site) {
      this.updatesiteParams(
        {
          partnerId: this.loggedInUser.partner_id,
          params: site,
        },
      )
        .then(() => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.sites.success.update'),
            notificationType: 'success',
          });
          this.fetchSites({
            partnerId: this.loggedInUser.partner_id,
            pageIndex: this.currentPageIndex,
            searchTerm: this.searchTerm,
          })
            .then((response) => {
              this.model = response;
              this.$eventBus.hideModal();
            })
            .catch((error) => {
              this.$swal
                .fire({
                  html: error[0],
                  type: 'error',
                  showCloseButton: true,
                  showCancelButton: false,
                  showConfirmButton: false,
                  focusConfirm: false,
                });
              this.$eventBus.hideModal();
            });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    actionMade(payload) {
      if (payload.actionType === 'edit') {
        this.fetchSite({
          partnerId: this.loggedInUser.partner_id,
          id: payload.id,
        })
          .then((site) => {
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t('app.sites.edit_site'),
                fields: this.siteAttributes,
                model: site,
                submitTitle: this.$t('app.sites.buttons.save'),
                cancelTitle: this.$t('app.sites.buttons.cancel'),
                modelName: 'sites',
              },
              on: {
                submit: this.updateSite,
              },
            });
          })
          .catch((error) => {
            const mappedErrors = error.map(x => ` ${x}`);
            this.$swal
              .fire({
                html: mappedErrors,
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      }
    },
    openSiteMap(payload) {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.sites.set_site'),
          fields: this.mapAttributes,
          model: payload,
          submitTitle: this.$t('app.sites.buttons.save'),
          cancelTitle: this.$t('app.sites.buttons.cancel'),
          modelName: 'sites',
          readOnly: true,
        },
      });
    },
    orderTable() {
      this.fetchSites({
        partnerId: this.loggedInUser.partner_id,
        pageIndex: this.currentPageIndex,
        searchTerm: this.searchTerm,
        orderInfo: {
          order: this.orderBy,
          direction: this.direction,
        },
      }).then((response) => {
        this.model = response;
      });
    },
    search(newTerm) {
      this.searchTerm = newTerm;
      this.currentPageIndex = 1;
      this.fetchSites({
        partnerId: this.loggedInUser.partner_id,
        pageIndex: this.currentPageIndex,
        searchTerm: this.searchTerm,
        orderInfo: {
          order: this.orderByBy,
          direction: this.order,
        },
      }).then((response) => {
        this.model = response;
      });
    },
  },
  watch: {
    currentPageIndex(newValue) {
      if (this.order !== undefined && this.direction !== undefined) {
        this.fetchSites({
          partnerId: this.loggedInUser.partner_id,
          pageIndex: newValue,
          searchTerm: this.searchTerm,
          orderInfo: {
            order: this.orderBy,
            direction: this.direction,
          },
        }).then((response) => {
          this.model = response;
        });
      }
    },
    userCurrentPageIndex(newValue) {
      this.fetchPartnerAdmins({
        pageIndex: newValue,
        orderInfo: {
          order: this.order,
          direction: this.direction,
        },
      }).then((response) => {
        this.partnerAdmins = response.users;
      });
    },
  },
};
</script>

<style lang="scss">
.sites-screen {
   /deep/ .configurable-list {
    .card-view {
      .panel-heading {
        .row {
          margin-right: 50%;
        }
        margin-top: -70px;
      }
    }
  }

  .partner-admin-table {
    margin-top: 70px;
    margin-right: 15px;
    margin-left: 15px;
  }
  .rounded {
    border-radius: 4px;
  }

  .name-cell {
    width: 15%;
  }
  .email-cell {
    width: 20%;
  }

  .phone-cell {
    width: 15%;
  }

  .specs-cell {
    display: flex !important;
    flex-wrap: wrap;
    margin-top: -0.5px !important;
    gap: 5px;
  }

  .delete-cell {
    width: 5%;
  }

  .edit-cell {
    width: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/partners/SitesScreen.vue